import {
  getCommonProductTerms,
  getVerticalWidgetProductTerms,
  ServicesWithTerms,
} from '@sravni/react-ugc/lib/ProductTerms';
import { BUSINESS_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { BusinessOffersType } from '@sravni/ugc/lib/specialOffers/types';

import type { OfferTab } from '../../helpers/getTabsInfo';

export const businessTabsInfo: Record<BusinessOffersType, OfferTab> = {
  [BUSINESS_OFFERS.biznesRegistration]: {
    key: { type: BUSINESS_OFFERS.biznesRegistration },
    label: 'Регистрация бизнеса',
    generalLink: '/biznes-registration/',
    generalLinkLabel: 'Все предложения по регистрации бизнеса',
    linkToOneProduct: null,
    getConditions: getCommonProductTerms(ServicesWithTerms.biznesRegistration),
    advertisingCategory: 'Регистрация бизнеса',
  },
  [BUSINESS_OFFERS.biznesRko]: {
    key: { type: BUSINESS_OFFERS.biznesRko },
    label: 'РКО',
    generalLink: '/rko/',
    generalLinkLabel: 'Все РКО',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.businessRko),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.businessRko),
    advertisingCategory: 'РКО',
  },
  // [BUSINESS_OFFERS.biznesDepozit]: {
  //   key: { type: BUSINESS_OFFERS.biznesDepozit },
  //   label: 'Бизнес-вклады',
  //   generalLink: '/biznes-vklady/',
  //   generalLinkLabel: 'Все вклады для бизнеса',
  //   linkToOneProduct: '',
  //   getConditions: getCommonProductTerms(ServicesWithTerms),
  //   advertisingCategory: 'Бизнес-вклады',
  // },
  [BUSINESS_OFFERS.biznesKredity]: {
    key: { type: BUSINESS_OFFERS.biznesKredity },
    label: 'Бизнес-кредиты',
    generalLink: '/biznes-kredity/',
    generalLinkLabel: 'Все кредиты для бизнеса',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.businessCredits),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.businessCredits),
    advertisingCategory: 'Бизнес-кредиты',
  },
  [BUSINESS_OFFERS.biznesAccounting]: {
    key: { type: BUSINESS_OFFERS.biznesAccounting },
    label: 'Бухгалтерия для бизнеса',
    generalLink: '/biznes-accounting/',
    generalLinkLabel: 'Все предложения по ведению бухгалтерского учёта',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.bukhgalteriyaDlyaBiznesa),
    advertisingCategory: 'Бухгалтерия для бизнеса',
  },
  [BUSINESS_OFFERS.bankovskieGarantii]: {
    key: { type: BUSINESS_OFFERS.bankovskieGarantii },
    label: 'Банковские гарантии',
    generalLink: '/biznes/bankovskie-garantii/',
    generalLinkLabel: 'Все расчёты стоимости банковской гарантии',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.bankGuarantees),
    advertisingCategory: 'Банковские гарантии',
  },
  [BUSINESS_OFFERS.biznesEkvajring]: {
    key: { type: BUSINESS_OFFERS.biznesEkvajring },
    label: 'Эквайринг',
    generalLink: '/biznes/ekvajring/',
    generalLinkLabel: 'Все тарифы по эквайрингу',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.acquiring),
    advertisingCategory: 'Эквайринг',
  },
  [BUSINESS_OFFERS.biznesMarketplace]: {
    key: { type: BUSINESS_OFFERS.biznesMarketplace },
    label: 'Бизнес на маркетплейсах',
    generalLink: '/biznes-marketplace/',
    generalLinkLabel: 'Все предложения по бизнесу на маркетплейсах',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.biznesNaMarketpleysakh),
    advertisingCategory: 'Бизнес на маркетплейс',
  },
  [BUSINESS_OFFERS.biznesLeasing]: {
    key: { type: BUSINESS_OFFERS.biznesLeasing },
    label: 'Лизинг',
    generalLink: '/biznes-leasing/',
    generalLinkLabel: 'Все предложения по лизингу',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.leasing),
    advertisingCategory: 'Лизинг',
  },
  [BUSINESS_OFFERS.biznesVed]: {
    key: { type: BUSINESS_OFFERS.biznesVed },
    label: 'ВЭД',
    generalLink: '/biznes-ved/',
    generalLinkLabel: 'Все предложения по ВЭД',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.biznesVed),
    advertisingCategory: 'ВЭД',
  },
  [BUSINESS_OFFERS.zarplatnyjProekt]: {
    key: { type: BUSINESS_OFFERS.zarplatnyjProekt },
    label: 'Зарплатные проекты',
    generalLink: '/biznes/zarplatnyj-proekt/',
    generalLinkLabel: 'Все предложения по зарплатным проектам',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.zarplatnyjProekt),
    advertisingCategory: 'Зарплатный проект',
  },
};
